import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Gilroy, system-ui, Trebuchet MS, Arial, Helvetica, Verdana',
    allVariants: {
      marginTop: 0,
    },
    body1: {
      fontWeight: 500,
    },
    body2: {
      fontWeight: 500,
    },
    h3: {
      fontSize: '3.3rem',
      fontWeight: 800,
      wordBreak: 'break-word',
    },
  },
  components: {
    MuiList: {
      styleOverrides: {
        root: {
          listStyle: 'disc',
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          display: 'list-item',
          listStylePosition: 'inside',
          marginBottom: '0.5rem',
        },
      },
    },
  },
});

export default theme;
